const registerES = {
	title: "Crear cuenta",
	email: "Correo electrónico",
	password: "Contraseña",
	firstName: "Nombre",
	lastName: "Apellido",
	submit: "Registrarse",
	loading: "Creando cuenta...",
	error: "No se pudo registrar el usuario",
	haveAccount: "¿Ya tienes una cuenta?",
	signIn: "Iniciar sesión",
	acceptTerms: "Acepto los",
	termsLink: "Términos y Condiciones",
	mustAcceptTerms: "Debes aceptar los Términos y Condiciones para continuar.",
};

export default registerES;
